module.exports = __webpack_public_path__ + "assets/img/img208.f40e75c5.png";